import { render, staticRenderFns } from "./pbbsettlefrm.vue?vue&type=template&id=507d9b8e"
import script from "./pbbsettlefrm.vue?vue&type=script&lang=js"
export * from "./pbbsettlefrm.vue?vue&type=script&lang=js"
import style0 from "./pbbsettlefrm.vue?vue&type=style&index=0&id=507d9b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports